import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data-test-id"];
import unescapedText from 'I18n/utils/unescapedText';
import UIIcon from 'UIComponents/icon/UIIcon';
import { useTheme as useSpecialtyTheme } from 'foundations-theming-specialty/utils';
import { BLACK } from '../../styles/colors';
import AICopilotTextInput from './AICopilotTextInput';
import { jsx as _jsx } from "react/jsx-runtime";
const getInputIconColorToken = (borderColor, value) => {
  if (borderColor === BLACK.NEUTRAL || borderColor === 'text-core-default' || borderColor === 'border-core-default') {
    return !value ? 'text-primary-disabled' : 'text-core-default';
  }
  // Default value: Magenta
  return !value ? 'breeze-fill-loading-dot-default' : 'breeze-border-field-default';
};
export const AISearchInput = _ref => {
  let {
      ['data-test-id']: dataTestId
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    borderColor = 'breeze-border-field-default',
    value,
    onChange,
    placeholder
  } = props;
  const theme = useSpecialtyTheme();
  return /*#__PURE__*/_jsx(AICopilotTextInput, Object.assign({}, props, {
    "data-test-id": dataTestId || 'threads-search-input',
    onChatInputChanged: onChange,
    value: value,
    icon: /*#__PURE__*/_jsx(UIIcon, {
      name: "search",
      style: {
        position: 'absolute',
        bottom: '7px',
        right: theme.space['250'],
        height: '26px',
        width: '26px',
        color: theme.color[getInputIconColorToken(borderColor, value)],
        textAlign: 'center'
      }
    }),
    placeholder: placeholder || unescapedText('aiComponentsUiLibrary.components.prompts.promptTemplates.searchPlaceholder'),
    role: "searchbox"
  }));
};
AISearchInput.displayName = 'AISearchInput';